// extracted by mini-css-extract-plugin
module.exports = {"backgroundStyleCollapse":"style_backgroundStyleCollapse__Ou4zu"};